export const names = {
	MS: 'Marc Spiegler',
	SS: 'Steven Sacks',
	PC: 'Pilar Corrias',
	NZ: 'Nadine Zeidler',
	LX: 'Leo Xu'
};

export const messagesBySection = [
	[{
		isCurator: true,
		name: names.MS,
		text: 'Greetings from...Basel',
		image: 'marc-selfie.jpg',
		aside: {
			title: names.MS,
			text: 'This month, Marc Spiegler has joined CNN Style as guest editor, commissioning a series of features on the topic of art and technology. As the Global Director of Art Basel, he leads its wide-ranging activities across the art world. Prior to joining Art Basel in 2007, he was a journalist for 15 years, writing about art, technology, video games, architecture, design and even politics.',
			gallery: {
				link: 'https://www.instagram.com/artbasel',
				images: ['bio-marc-01.jpg', 'bio-marc-02.jpg', 'bio-marc-03.jpg', 'bio-marc-04.jpg']
			}
		}
	}, {
		name: names.SS,
		text: 'Morning from Steve Sacks',
		image: 'steven-selfie.jpg',
		aside: {
			title: names.SS,
			text: 'Steven Sacks is the founder of bitforms gallery in New York. Since 2001, he has worked to establish bitforms as the world’s leading new media fine art gallery, and continues to nurture artists who push the boundaries of how art is created and defined.',
			gallery: {
				link: 'https://www.instagram.com/bitforms',
				images: ['bio-steve-01.jpg', 'bio-steve-02.jpg', 'bio-steve-03.jpg', 'bio-steve-04.jpg']
			}
		}
	}, {
		name: names.PC,
		text: 'Hi from rainy London',
		image: 'pilar-selfie.jpg',
		aside: {
			title: names.PC,
			text: 'Pilar Corrias has been working as a contemporary gallerist since the early ‘90s, founding her eponymous gallery in London in 2008. It is dedicated to supporting ambitious projects by contemporary artists such as Philippe Parreno, whose forthcoming Tate Modern Turbine Hall commission opens in October 2016.',
			gallery: {
				link: 'https://www.instagram.com/pilarcorriasgallery',
				images: ['bio-pilar-01.jpg', 'bio-pilar-02.jpg', 'bio-pilar-03.jpg', 'bio-pilar-04.jpg']
			}
		}
	}, {
		name: names.NZ,
		text: 'Hello from Berlin',
		image: 'nadine-selfie.jpg',
		aside: {
			title: names.NZ,
			text: 'Nadine Zeidler is the co-founder of Kraupa-Tuskany Zeidler gallery in Berlin, with her partner Amadeo Kraupa-Tuskany. Together they champion art that operates outside linear notions of thinking, and engages with subversive and hybrid forms of artistic production.',
			gallery: {
				link: 'http://aktnz.com',
				images: ['bio-nadine-01.jpg', 'bio-nadine-02.jpg', 'bio-nadine-03.jpg', 'bio-nadine-04.jpg']
			}
		}
	}, {
		name: names.LX,
		text: 'Hello from Shanghai',
		image: 'leo-selfie.jpg',
		aside: {
			title: names.LX,
			text: 'Leo Xu is a writer and curator based in Shanghai who founded Leo Xu Projects in 2011. He has represented and collaborated with a stable of young Chinese and international artists, and was named one of the 30 most influential global art world figures under 30 by Blouin Artinfo in 2012.',
			gallery: {
				link: 'https://www.instagram.com/leoxuprojects',
				images: ['bio-leo-01.jpg', 'bio-leo-02.jpg', 'bio-leo-03.jpg', 'bio-leo-04.jpg']
			}
		}
	}, {
		name: names.PC,
		text: 'So what\'s the first question?'
	}, {
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'First, the basics: Who buys these sorts of works?'
	}, {
		name: names.PC,
		text: 'collectors, museums....people who understand'
	}, {
		name: names.LX,
		text: 'Ppl who relate to it, buy it'
	}, {
		name: names.LX,
		text: 'Not necessarily young kids'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'So it\'s not a demographic, but a psychographic?'
	}, {
		name: names.SS,
		text: 'I have no defined audience but def people who are less conservative and excited about innovation in the arts'
	}, {
		name: names.LX,
		text: 'Ppl who cannot handle their iPhone can also be highly into digital or hi tech art'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'really leo? 😂'
	}, {
		name: names.LX,
		text: 'Yes'
	}, {
		name: names.SS,
		text: 'Yes but they tend to call for help a lot 😉'
	}, {
		name: names.PC,
		text: 'it\'s my role to make people understand. that\'s what a gallery does - it educates.'
	}, {
		name: names.PC,
		image: 'pillar-corrias-gallery.gif',
		caption: 'Pilar Corrias\' London gallery.'
	}, {
		name: names.NZ,
		text: 'The collectors really come from all generations.'
	}, {
		name: names.LX,
		text: 'Ppl are amazed by how much this type of art allows them to see the world in a different light'
	}, {
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'Does the same apply to museums? Are older curators open to this sort of work? i.e. is there a generation gap?'
	}, {
		name: names.NZ,
		text: 'the gap is definitely closing'
	}, {
		name: names.PC,
		text: 'yes, there is a generation gap. some museums are more forward thinking'
	}, {
		name: names.NZ,
		text: 'there are a lot of young curators and museums making acquisition decisions now that are very daring'
	}, {
		name: names.PC,
		text: 'in 10 years I doubt we will be having a conversation like this'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'agreed Pilar - In 10 years, the museums will be run by millennials'
	}, {
		name: names.SS,
		text: 'It will be something else...like the VR experience that is now gaining momentum'
	}, {
		name: names.PC,
		text: 'yes, museums have an important role. they are engaging now because luckily there are smart curators who can see how the world works'
	}, {
		name: names.PC,
		image: 'vr-museum.jpg',
		caption: 'Courtesy Gabrielle Lurie/AFP/Getty Images'
	}, {
		name: names.NZ,
		text: 'agree - and there are many private collectors with their own museums. So they are often more likely to buy more complex works.'
	}, {
		isCurator: true,
		name: names.MS,
		text: '@pilar, more so than privates?'
	}, {
		name: names.PC,
		text: 'in a way yes, larger collections both public and private tend to want to represent their times. digital is as real for us as what is physical'
	}, {
		name: names.SS,
		text: 'My kids are coding. All kids are coding. There is a wider pool of people that will be available to address the preservation needs of all new media concerns in the future'
	}], [{
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'Do you worry about copyright lawsuits, given how material is being sourced online from YouTube / Google images / etc?'
	}, {
		name: names.SS,
		text: 'Yes. We have been sued!'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'steve, 😱 it happens. who won?'
	}, {
		name: names.SS,
		text: 'Well luckily we sold the last work so the cease and desist was not an issue.'
	}, {
		name: names.NZ,
		text: 'Copyrights are definitely an issue'
	}, {
		name: names.PC,
		text: 'we deal with it. I\'ve never been sued. however I also know of the same kind of issues in the non-digital art world'
	}, {
		name: names.SS,
		text: 'It\'s tricky but there are precedents'
	}, {
		name: names.NZ,
		text: 'The Richard Prince law suits are helpful here...'
	}, {
		name: names.NZ,
		text: 'to understand when an artwork has become autonomous and is not infringing copyrights.'
	}, {
		name: names.NZ,
		video: {
			poster: 'cnn-richard-prince.jpg',
			mp4: 'cnn-richard-prince.mp4',
			webm: 'cnn-richard-prince.webm'
		},
		caption: 'CNN reports on artist Richard Prince. 2nd June 2015.'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'Of course, if you\'re doing something on Facebook or Instagram, the platform owns your work.'
	}, {
		name: names.SS,
		text: 'I also believe web sites are public art'
	}, {
		name: names.SS,
		text: 'The selling of the .com is interesting and has potential'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'yes, but you own your own website content. "your" content on FB/IG belongs to them.'
	}, {
		name: names.SS,
		text: 'True. It\'s more of a performance with them'
	}, {
		name: names.LX,
		text: 'China is a particular case. Imagine all those crazy apps that were created by Chinese entrepreneurs to imitate their western counterparts, but in the end became monsters. Artists and collectors growing and living in this environment are very affected'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'Aside from Amalia Ulman\'s \'Excellences and Perfections\', are there other examples of artists using social-media platforms as the "support" for their work?'
	}, {
		isCurator: true,
		name: names.MS,
		video: {
			poster: 'marc-amalia-cut.jpg',
			mp4: 'marc-amalia-cut.mp4',
			webm: 'marc-amalia-cut.webm'
		},
		caption: 'Marc Spiegler: Why Amalia Ulman\'s \'Excellences & Perfections\' was a turning point for digital art.'
	}, {
		name: names.SS,
		text: 'A few of my artists - Addie Wagenkkecht, Siebren Versteeg'
	}, {
		name: names.SS,
		image: 'siebren.gif',
		caption: 'Siebren Versteeg, LIKE, 2014, courtesy bitforms gallery. The left panel of LIKE continuously generates an abstract composition using algorithms developed by the artist. Every minute an image from the algorithmn is uploaded to Google image search. The right panel displays the most accurate findings.'
	}, {
		name: names.PC,
		text: 'when Amalia Ulman\'s work is presented outside Instagram - i.e. as a print on the wall - it loses potency'
	}, {
		name: names.PC,
		image: 'amalia-ulman.gif',
		caption: 'Amalia Ulman, \'Excellences and Perfections\'. Courtesy of the artist and James Fuentes, New York.'
	}, {
		name: names.SS,
		text: 'Agreed'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'well, it doesn\'t have 90K people potentially interacting with it in the palm of their hand'
	}, {
		name: names.NZ,
		text: 'The rhizome of the vast image economy online – be it in FB, IG, Tumblr etc are very important for a lot of artists from younger and older generations.'
	}, {
		name: names.LX,
		text: 'Social media has been not just inspiration but materials or media for artists'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'Leo, can you expand on that?'
	}, {
		name: names.LX,
		text: 'It becomes another institution for artists here'
	}, {
		name: names.SS,
		text: 'Yes this "post-internet" phrase was attached to that group'
	}, {
		name: names.PC,
		text: 'I\'m so bored of the "post-internet" phrase'
	}, {
		name: names.SS,
		text: 'Yes but had to bring it up!!'
	}, {
		name: names.PC,
		text: 'i agree i nearly said it earlier!'
	}, {
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'oooooohhhh. "post-internet"? my bete noire. How do you feel about the term "post-internet"?'
	}, {
		isCurator: true,
		name: names.MS,
		image: 'postinternet-definition.jpg'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'I feel like we could not possibly be in a *less* post-internet moment'
	}, {
		name: names.PC,
		text: 'we are all in it!! there is nothing "post" here'
	}, {
		name: names.SS,
		text: 'Post-internet is not great but I did see a large movement a few years back with a generation that had a different aesthetic attitude and competence for all things Internet'
	}, {
		name: names.NZ,
		text: 'if we take the "post" literally we can just move on to other more interesting ways of looking at some artist\'s practices.'
	}, {
		name: names.PC,
		text: 'exactly Nadine'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'post-internet art to me is what happens after a global electromagnetic pulse bomb kills off all electrically powered devices'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'I prefer digital-native, because that\'s where I see the art having shifted'
	}, {
		name: names.SS,
		text: 'Kinda makes more sense!'
	}, {
		name: names.NZ,
		text: 'lol 😂'
	}, {
		isCurator: true,
		name: names.MS,
		text: '😃'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'if anything it\'s not "post-internet" but "pervasive-internet" art'
	}, {
		name: names.SS,
		text: 'All artists are becoming digital native, but all are not expressing the digital aspect as a tool for advancement in process and thinking'
	}, {
		name: names.NZ,
		text: 'Ultimately it\'s important to look at what artists are doing. As I said before I understand the internet or the digital more as a current infrastructure for artists, art production and communication about art'
	}], [{
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'How is it different to represent digital natives versus older artists, if at all?'
	}, {
		name: names.PC,
		text: 'ideas are ideas and great artists reflect their times'
	}, {
		name: names.NZ,
		text: 'Not sure, but artists are definitely aware that the artworks (and their documentation) will have a life of their own in the digital realm'
	}, {
		name: names.PC,
		text: 'collectors always challenge me about this. I have a lot of interaction with institutions to discuss the future of collecting these works.'
	}, {
		name: names.SS,
		text: 'Technology has a much higher cultural and utilitarian relevance than that of the earlier generations -'
	}, {
		name: names.NZ,
		text: 'or even think ahead of their time'
	}, {
		name: names.PC,
		text: 'yes, nadine, I\'m with you 👍'
	}, {
		name: names.SS,
		text: 'Collecting these works 😱 that\'s another chat'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'No Steve that is THIS chat!'
	}, {
		name: names.NZ,
		text: 'Collecting new forms of art was always a challenge'
	}, {
		name: names.LX,
		text: 'But maybe there comes the time that collectors and public are also thinking of new ways of collecting and consumption? Since many younger generations of collectors have themselves been immersed in new tech for decades already. It is not the same situation as photo and video ages ago.'
	}, {
		name: names.PC,
		text: 'I\'ve recently been looking into making digital certificates. So, not objects are traded'
	}, {
		name: names.PC,
		image: 'certificate-of-authenticity.jpg',
		caption: 'This digital certificate from Berlin-based company ascribe comes with a unique cryptographic ID.'
	}, {
		name: names.NZ,
		text: 'Even more so with video and performance'
	}, {
		name: names.PC,
		text: 'yes, it\'s a fun challenge. We are making history'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'Agreed with Nadine - but gallerists always find a way to convince collectors to embrace the avante-garde. That\'s your genius...'
	}, {
		name: names.PC,
		text: 'nadine have you looked into digital certificates? it makes sense but collectors always want the physical thing.'
	}, {
		name: names.NZ,
		text: 'No, haven\'t looked into dig certificates'
	}, {
		isCurator: true,
		name: names.MS,
		text: '@pilar, can you explain that in more detail?'
	}, {
		name: names.PC,
		text: 'so, for example, Ian Cheng makes works that are simulations/programs/algorithms. I don\'t need to give a collector a physical object really eg. mini Mac . I can just transfer the simulation file hosted on a password protected server. I can send an encrypted certificate as well'
	}, {
		name: names.PC,
		image: 'ian-cheng1.gif',
		caption: 'Excerpt from Ian Cheng, Something Thinking of You, 2015. Courtesy the artist and Pilar Corrias Gallery, London.'
	}, {
		name: names.SS,
		text: 'We are very focused on the preservation and distribution of file- based artworks. And working with a few outside sources to be revealed soon.'
	}, {
		name: names.SS,
		text: 'Major issue is how collectors manage and control the file-based works. It\'s becoming a concern for larger collectors of this work.'
	}, {
		name: names.PC,
		text: 'I just sold Parreno to the Met and Philadelphia Museums and they are archiving the algorithms on their main servers so it will be saved over time and updated as necessary'
	}, {
		name: names.PC,
		image: 'parreno.gif',
		caption: 'Philippe Parreno, With a Rhythmic Instinction to be Able to Travel Beyond Existing Forces of Life (Green, Rule#1), 2014. Courtesy Pilar Corrias Gallery, London and the artist. Photo: Andrea Rossetti.'
	}, {
		name: names.LX,
		text: 'And what about presentation? Let\'s say some art is very dependent on a certain service or application like Google which is blocked in many countries... Meaning the work will be defunct in some regions'
	}, {
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'Do you worry about digital works getting hacked / leaked etc?'
	}, {
		name: names.SS,
		text: 'Yes it\'s an issue especially for higher priced works. There are some new encryption techniques that will help this. Right now the old school signed certificate is what adds the value'
	}, {
		name: names.PC,
		text: 'no. I\'m doing the same thing with MoMA and another artist. museums need to embrace the art of their times and this is an important issue for them. Files can be encrypted and can then not be played without being registered by those who have access'
	}, {
		name: names.PC,
		text: 'money is not physical anymore. It\'s just a matter of time certificates won\'t be either'
	}], [{
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'If you could give any historical artist access to today\'s technology, who would it be?'
	}, {
		name: names.PC,
		text: 'Leonardo da Vinci'
	}, {
		name: names.PC,
		image: 'leonardo-da-vinci.jpg',
		caption: 'Courtesy Hulton Archive/Getty Images'
	}, {
		name: names.SS,
		text: 'Dali'
	}, {
		name: names.SS,
		image: 'salvador-dali.jpg',
		caption: 'Courtesy Hulton Archive/Getty Images'
	}, {
		name: names.SS,
		text: 'He would own VR'
	}, {
		name: names.NZ,
		text: 'Marcel Broodthaers'
	}, {
		name: names.NZ,
		image: 'broodthaers.jpg',
		caption: 'Courtesy Iguana Press/Getty Images'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'Now I want a time machine 👽'
	}, {
		name: names.PC,
		text: 'take me with you'
	}, {
		name: names.PC,
		text: '🚀'
	}, {
		name: names.LX,
		text: 'Bosch'
	}, {
		name: names.LX,
		image: 'bosch.jpg',
		caption: 'Courtesy Hulton Archive/Getty Images'
	}, {
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'If you could only use one software/app in your gallery work what would it be?'
	}, {
		name: names.PC,
		text: 'Gmail'
	}, {
		name: names.LX,
		text: 'Gmail'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'wow, Leo, I expected wechat'
	}, {
		name: names.PC,
		text: 'maybe snapchat 😝'
	}, {
		name: names.NZ,
		text: 'We are still looking for this program. If you find it let me know...'
	}, {
		name: names.PC,
		image: 'pilar-animal-selfie.jpg'
	}, {
		isCurator: true,
		name: names.MS,
		text: '🙌 pilar'
	}, {
		name: names.SS,
		text: 'FB works well for us'
	}], [{
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'how does tech change art in the next five years?'
	}, {
		name: names.PC,
		text: 'well, i was talking about digital certificates earlier'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'will they get significant traction in the market?'
	}, {
		name: names.PC,
		text: 'I hope so, I\'m working on it with a lawyer and an encryption company'
	}, {
		name: names.SS,
		text: 'Smarter, smaller objects and user friendly coding tools will continue to offer artists more options. Better control and distribution of file-based artworks.'
	}, {
		name: names.SS,
		text: 'I will have a solution for all galleries soon.'
	}, {
		name: names.PC,
		text: 'really like what?'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'Watch the skies, folks...'
	}, {
		name: names.PC,
		text: 'you can sell through Instagram'
	}, {
		name: names.PC,
		text: 'i have many times'
	}, {
		name: names.LX,
		text: 'On and off'
	}, {
		name: names.NZ,
		text: 'yes it\'s more about how to filter information'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'I think Instagram is the strongest art-sales platform at the moment, even if it\'s not purpose-built for that'
	}, {
		name: names.PC,
		text: 'it\'s fun when you go to an opening and you have already seen the show on Instagram before you get there'
	}, {
		name: names.NZ,
		text: 'agree and also through wechat'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'I feel like it kind of ruins things. "See it on Instagram" is a dismissive to me...'
	}, {
		name: names.PC,
		text: 'not really, not if you\'re curious, it\'s a good place for research'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'That said, great art always works better in person.'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'So it\'s a different experience.'
	}, {
		name: names.NZ,
		text: 'I also think these platforms are great for research'
	}, {
		name: names.NZ,
		text: 'That\'s how we mainly use them TBH'
	}, {
		name: names.PC,
		text: 'personal contact is always best, but knowing where to go is done through Instagram'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'for research it\'s fantastic. I know a lot of people who actively stalk curator IG feeds to see what the "liked"'
	}, {
		isCurator: true,
		name: names.MS,
		text: '12 Art Curators to Follow on Instagram',
		link: 'http://edition.cnn.com/2016/06/23/arts/12-art-curators-to-follow-on-instagram/index.html'
	}, {
		name: names.NZ,
		text: 'Later you can go and see the things you found interesting in person'
	}, {
		name: names.PC,
		text: 'exactly nadine'
	}, {
		name: names.NZ,
		text: 'When curators post things it\'s usually too late for us...'
	}, {
		name: names.NZ,
		text: '😉'
	}, {
		name: names.PC,
		text: 'always stay ahead of the game'
	}, {
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'So does Instagram make us more or less likely to go all the way across town to see a show? Specifically: *your* show?'
	}, {
		name: names.PC,
		text: 'yes, totally of course'
	}, {
		name: names.NZ,
		text: 'It makes us more likely to see a show you really liked on Instagram. But you might skip one you didn\'t like on social media. That\'s a danger'
	}, {
		name: names.SS,
		text: 'More likely especially if there are a lot of likes...'
	}, {
		name: names.NZ,
		text: 'But again - It helps filtering information...'
	}, {
		name: names.PC,
		text: 'you know you can buy likes and followers right?'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'Here\'s the rub: some shows don\'t translate to small square screens.💀'
	}, {
		name: names.SS,
		text: 'Yes especially with larger immersive works -'
	}, {
		name: names.PC,
		text: 'that\'s def true'
	}, {
		name: names.NZ,
		text: 'exactly marc'
	}, {
		name: names.SS,
		text: 'Like Rafa\'s piece at Unlimited - it\'s huge!'
	}, {
		name: names.SS,
		image: 'zoom-pavillion.gif',
		caption: 'Zoom Pavilion by Rafael Lozano-Hemmer and Krzysztof Wodiczko, 2015. Courtesy of bitforms gallery and the artists'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'it\'s like "wallpower" for the digital age: "screen sexiness"'
	}, {
		name: names.PC,
		text: 'there is always video on IG'
	}, {
		name: names.SS,
		text: 'Scale is still challenging'
	}, {
		name: names.PC,
		text: 'yes we talk about that here'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'true, but I doubt anyone watches all the videos in their feed.'
	}, {
		isQuestion: true,
		isCurator: true,
		name: names.MS,
		text: 'do you invest a lot of time in your gallery\'s social-media presence?'
	}, {
		name: names.SS,
		text: 'Yes. Pretty high percentage managing all the formats!!!'
	}, {
		name: names.PC,
		text: 'it\'s a balance between being active but not overloading'
	}, {
		name: names.NZ,
		text: 'We don\'t have gallery social media accounts'
	}, {
		name: names.PC,
		text: 'you mean you have your own personal one or none at all?'
	}, {
		name: names.SS,
		text: 'We have too many...'
	}, {
		name: names.NZ,
		text: 'We do have personal accounts of course'
	}, {
		name: names.LX,
		text: 'we don\'t invest much in social media or Instagram it is just very personal thing'
	}, {
		name: names.LX,
		text: 'Gallery Instagrams to me are just bulletin'
	}, {
		name: names.PC,
		text: 'me too it\'s personal'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'It\'s a lot of work. That\'s why I have never posted a pic on my instagram account. Not ready to do that treadmill.'
	}, {
		name: names.PC,
		text: 'it\'s cheaper than advertising on art forum'
	}, {
		name: names.PC,
		text: 'in fact, i don\'t advertise'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'When did you stop?'
	}, {
		name: names.PC,
		text: 'month 6 of the gallery'
	}, {
		name: names.PC,
		text: 'gallery is now 7 and half years old'
	}, {
		name: names.NZ,
		text: 'Isn\'t it more about supporting the magazines than about advertising?'
	}, {
		name: names.SS,
		text: 'I haven\'t advertised in 8 years'
	}, {
		name: names.PC,
		text: 'well I have to support so many museum shows and artists projects and art works.'
	}, {
		name: names.PC,
		text: 'the best way i can advertise the gallery is by allowing artists to produce incredible works'
	}, {
		name: names.NZ,
		text: 'I know - It\'s just why I sometimes feel it\'s hard to say no...'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'You will learn, Nadine...'
	}, {
		isCurator: true,
		name: names.MS,
		text: 'hey, we\'re going far afield and way over time.'
	}, {
		name: names.SS,
		text: 'See you all soon. Thanks Marc and CNN....'
	}, {
		name: names.NZ,
		text: 'Thank you all'
	}, {
		name: names.LX,
		text: 'Thanks Marc and CNN and everyone'
	}, {
		name: names.PC,
		text: 'thanks for the chat everybody 👋'
	}, {
		isCurator: true,
		name: names.MS,
		text: '--------------------- The End ------------------------'
	}, {
		name: names.PC,
		text: 'good night shanghai 😘'
	}, {
		name: names.LX,
		text: 'Nite!'
	}, {
		name: names.PC,
		text: 'sweet dreams lovely one 💐 ✨'
	}, {
		name: names.LX,
		text: '✨'
	}]
];

export const messageSections = [{
	number: 'I',
	title: 'Who buys digital art?'
}, {
	number: 'II',
	title: 'Are you worried about getting sued?'
}, {
	number: 'III',
	title: 'How do you represent digital artists?'
}, {
	number: 'IV',
	title: 'What would Da Vinci do with Snapchat?'
}, {
	number: 'V',
	title: 'What is the next big thing?'
}];

export const breakpointSmallTo = 584;
export const breakpointLargeFrom = 585;



/** WEBPACK FOOTER **
 ** ./config.js
 **/